import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import CommentsWidgetList from '../../../../../../../../components/CommentsWidgetList';
import withWidgetHeaderAndFooter from '../../../../../../../../components/withWidgetHeaderAndFooter';
import withWidgetData from '../../../../../../../../components/withWidgetData';
import withReportFilterProps from '../../../../../../../../components/withReportFilterProps';
import withQueryStringProps from '../../../../../../../../components/withQueryStringProps';
import notifyPhantomWhenMounted from '../../../../../../../../components/notifyPhantomWhenMounted';

@withReportFilterProps
@withWidgetData(
  graphql`
    query ExportCommentsWidgetQuery(
      $widgetId: ID!
      $from: String!
      $to: String!
      $deviceIds: [ID]!
      $filterComments: Boolean!
      $demoData: Boolean!
      $questionFilters: [QuestionFilterInput]
      $commentExtraColumns: [ID]
      $count: Int!
      $cursor: String
    ) {
      widget(id: $widgetId) {
        id
        name
        config {
          subtitle
          hideHeader
          hideCommentTime
          commentExtraColumns {
            title
            questionId
          }
          question {
            text {
              language
              text
            }
            answersReport(
              from: $from
              to: $to
              deviceIds: $deviceIds
              filterComments: $filterComments
              demoData: $demoData
              questionFilters: $questionFilters
            ) {
              count
            }
            ...CommentsWidgetList_question
          }
        }
      }
    }
  `,
  {
    count: 1000,
  },
)
@notifyPhantomWhenMounted({widgetIdSuffix: '-print'})
@withWidgetHeaderAndFooter({hideFooter: true})
@withQueryStringProps(['print'])
class ExportCommentsWidget extends Component {

  render() {
    const listMargin = 20;
    const styles={
      listWrapper: {
        margin: `0 ${listMargin}px ${listMargin}px`,
      },
    };

    const widget = this.props.widget;
    const question = widget.config.question;
    return (
      <div style={styles.listWrapper}>
        <CommentsWidgetList
          question={question}
          width={this.props.width-(listMargin*2)}
          scrolledToBottom={false}
          showTerminalColumn={this.props.deviceIds.length > 1}
          showTimeColumn={!widget.config.hideCommentTime}
          questionFilters={this.props.questionFilters && this.props.questionFilters.filter(qf => !!qf.options)}
          showLocation={this.props.report.groupByLocation}
          extraColumns={widget.config.commentExtraColumns}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  ExportCommentsWidget,
  graphql`
    fragment ExportCommentsWidget_report on Report {
      ...withReportFilterProps_report
    }
    fragment ExportCommentsWidget_widget on Widget {
      id
      type
      ...withWidgetData_widget
    }
    fragment ExportCommentsWidget_surveys on SurveyConnection {
      ...withWidgetData_surveys
    }
  `,
);



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/UserReportGrid/components/ExportCommentsWidget/ExportCommentsWidget.js